import Component from '@glimmer/component';
import { hash } from '@ember/helper';
import { eq } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { HdsDropdown } from '@hashicorp/design-system-components/components';

/**
 *
 * `PageOrganizationsActions` is a dropdown menu used to manage an organization.
 *
 *
 * ```
 * <Page::Organizations::Actions
 *   @isToggleIcon={{true}}
 *   @next='cloud.orgs.detail'
 *   @organization={{organization}}
 *   @canRename={{true}}
 * />
 * ```
 *
 * @class PageOrganizationsActions
 *
 */
export default class PageOrganizationsActions extends Component {
  <template>
    <HdsDropdown data-test-organization-actions-container as |dd|>
      {{#if (eq @isToggleIcon true)}}
        <dd.ToggleIcon
          @hasChevron={{false}}
          @icon="more-horizontal"
          @text={{t "components.form.more"}}
          data-test-organization-actions-manage
          data-test-organization-actions-toggle-icon
        />
      {{else}}
        <dd.ToggleButton
          @color="secondary"
          @text={{t "components.form.manage"}}
          data-test-organization-actions-manage
          data-test-organization-actions-toggle-button
        />
      {{/if}}

      {{#if @canRename}}
        <dd.Interactive
          @icon="edit"
          @model={{@organization.id}}
          @query={{hash next=@next}}
          @route="cloud.orgs.detail.settings.index.rename"
          @text={{t "components.page.organizations.list.actions.rename"}}
          data-test-organization-actions-rename-link
        />
      {{/if}}

      <dd.Interactive
        @icon="eye"
        @model={{@organization.id}}
        @route="cloud.orgs.detail.index"
        @text={{t "components.page.organizations.list.actions.view"}}
        data-test-organization-actions-view-link
      />
    </HdsDropdown>
  </template>
}
